'use client';
"use strict";

var _excluded = ["className", "children"],
    _excluded2 = ["type", "aria-label"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  Stat: function Stat() {
    return _Stat;
  },
  StatArrow: function StatArrow() {
    return _StatArrow;
  },
  StatDownArrow: function StatDownArrow() {
    return _StatDownArrow;
  },
  StatGroup: function StatGroup() {
    return _StatGroup;
  },
  StatHelpText: function StatHelpText() {
    return _StatHelpText;
  },
  StatLabel: function StatLabel() {
    return _StatLabel;
  },
  StatNumber: function StatNumber() {
    return _StatNumber;
  },
  StatUpArrow: function StatUpArrow() {
    return _StatUpArrow;
  },
  useStatStyles: function useStatStyles() {
    return _useStatStyles;
  }
});

module.exports = __toCommonJS(src_exports); // src/stat.tsx

var import_react_context = require("@chakra-ui/react-context");

var import_system = require("@chakra-ui/system");

var import_shared_utils = require("@chakra-ui/shared-utils");

var import_jsx_runtime = require("react/jsx-runtime");

var _ref = (0, import_react_context.createContext)({
  name: "StatStylesContext",
  errorMessage: "useStatStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Stat />\" "
}),
    _ref2 = _slicedToArray(_ref, 2),
    StatStylesProvider = _ref2[0],
    _useStatStyles = _ref2[1];

var _Stat = (0, import_system.forwardRef)(function Stat2(props, ref) {
  var styles = (0, import_system.useMultiStyleConfig)("Stat", props);

  var statStyles = _objectSpread({
    position: "relative",
    flex: "1 1 0%"
  }, styles.container);

  var _ref3 = (0, import_system.omitThemingProps)(props),
      className = _ref3.className,
      children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, _excluded);

  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(StatStylesProvider, {
    value: styles,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_system.chakra.div, _objectSpread(_objectSpread({
      ref: ref
    }, rest), {}, {
      className: (0, import_shared_utils.cx)("chakra-stat", className),
      __css: statStyles,
      children: /* @__PURE__ */(0, import_jsx_runtime.jsx)("dl", {
        children: children
      })
    }))
  });
});

_Stat.displayName = "Stat"; // src/stat-arrow.tsx

var import_icon = require("@chakra-ui/icon");

var import_system2 = require("@chakra-ui/system");

var import_jsx_runtime2 = require("react/jsx-runtime");

var _StatDownArrow = function _StatDownArrow(props) {
  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_icon.Icon, _objectSpread(_objectSpread({
    color: "red.400"
  }, props), {}, {
    children: /* @__PURE__ */(0, import_jsx_runtime2.jsx)("path", {
      fill: "currentColor",
      d: "M21,5H3C2.621,5,2.275,5.214,2.105,5.553C1.937,5.892,1.973,6.297,2.2,6.6l9,12 c0.188,0.252,0.485,0.4,0.8,0.4s0.611-0.148,0.8-0.4l9-12c0.228-0.303,0.264-0.708,0.095-1.047C21.725,5.214,21.379,5,21,5z"
    })
  }));
};

_StatDownArrow.displayName = "StatDownArrow";

function _StatUpArrow(props) {
  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_icon.Icon, _objectSpread(_objectSpread({
    color: "green.400"
  }, props), {}, {
    children: /* @__PURE__ */(0, import_jsx_runtime2.jsx)("path", {
      fill: "currentColor",
      d: "M12.8,5.4c-0.377-0.504-1.223-0.504-1.6,0l-9,12c-0.228,0.303-0.264,0.708-0.095,1.047 C2.275,18.786,2.621,19,3,19h18c0.379,0,0.725-0.214,0.895-0.553c0.169-0.339,0.133-0.744-0.095-1.047L12.8,5.4z"
    })
  }));
}

_StatUpArrow.displayName = "StatUpArrow";

function _StatArrow(props) {
  var type = props.type,
      ariaLabel = props["aria-label"],
      rest = _objectWithoutProperties(props, _excluded2);

  var styles = _useStatStyles();

  var BaseIcon = type === "increase" ? _StatUpArrow : _StatDownArrow;
  var defaultAriaLabel = type === "increase" ? "increased by" : "decreased by";
  var label = ariaLabel || defaultAriaLabel;
  return /* @__PURE__ */(0, import_jsx_runtime2.jsxs)(import_jsx_runtime2.Fragment, {
    children: [/* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_system2.chakra.span, {
      srOnly: true,
      children: label
    }), /* @__PURE__ */(0, import_jsx_runtime2.jsx)(BaseIcon, _objectSpread(_objectSpread({
      "aria-hidden": true
    }, rest), {}, {
      __css: styles.icon
    }))]
  });
}

_StatArrow.displayName = "StatArrow"; // src/stat-group.tsx

var import_shared_utils2 = require("@chakra-ui/shared-utils");

var import_system3 = require("@chakra-ui/system");

var import_jsx_runtime3 = require("react/jsx-runtime");

var _StatGroup = (0, import_system3.forwardRef)(function StatGroup2(props, ref) {
  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(import_system3.chakra.div, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    role: "group",
    className: (0, import_shared_utils2.cx)("chakra-stat__group", props.className),
    __css: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-around",
      alignItems: "flex-start"
    }
  }));
});

_StatGroup.displayName = "StatGroup"; // src/stat-help-text.tsx

var import_shared_utils3 = require("@chakra-ui/shared-utils");

var import_system4 = require("@chakra-ui/system");

var import_jsx_runtime4 = require("react/jsx-runtime");

var _StatHelpText = (0, import_system4.forwardRef)(function StatHelpText2(props, ref) {
  var styles = _useStatStyles();

  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_system4.chakra.dd, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    className: (0, import_shared_utils3.cx)("chakra-stat__help-text", props.className),
    __css: styles.helpText
  }));
});

_StatHelpText.displayName = "StatHelpText"; // src/stat-label.tsx

var import_shared_utils4 = require("@chakra-ui/shared-utils");

var import_system5 = require("@chakra-ui/system");

var import_jsx_runtime5 = require("react/jsx-runtime");

var _StatLabel = (0, import_system5.forwardRef)(function StatLabel2(props, ref) {
  var styles = _useStatStyles();

  return /* @__PURE__ */(0, import_jsx_runtime5.jsx)(import_system5.chakra.dt, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    className: (0, import_shared_utils4.cx)("chakra-stat__label", props.className),
    __css: styles.label
  }));
});

_StatLabel.displayName = "StatLabel"; // src/stat-number.tsx

var import_shared_utils5 = require("@chakra-ui/shared-utils");

var import_system6 = require("@chakra-ui/system");

var import_jsx_runtime6 = require("react/jsx-runtime");

var _StatNumber = (0, import_system6.forwardRef)(function StatNumber2(props, ref) {
  var styles = _useStatStyles();

  return /* @__PURE__ */(0, import_jsx_runtime6.jsx)(import_system6.chakra.dd, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    className: (0, import_shared_utils5.cx)("chakra-stat__number", props.className),
    __css: _objectSpread(_objectSpread({}, styles.number), {}, {
      fontFeatureSettings: "pnum",
      fontVariantNumeric: "proportional-nums"
    })
  }));
});

_StatNumber.displayName = "StatNumber"; // Annotate the CommonJS export names for ESM import in node:

0 && (module.exports = {
  Stat: _Stat,
  StatArrow: _StatArrow,
  StatDownArrow: _StatDownArrow,
  StatGroup: _StatGroup,
  StatHelpText: _StatHelpText,
  StatLabel: _StatLabel,
  StatNumber: _StatNumber,
  StatUpArrow: _StatUpArrow,
  useStatStyles: _useStatStyles
});